import { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { SUBMENUS } from 'components/Shared/Enums/SubMenusEnum';
import { encodeBase64UrlSafe } from 'components/Utils/utils';
import {
  criaCookieToken,
  getConfigAmbienteDominio,
  refreshAccessToken
} from '../../../services/authentication/auth';
import { useNavegacao } from '../../../hooks/useNavegacao';
import { origemConfiavel } from '../../../config/origensConfiaveis';

const IframeComponentHook = ({ scrIframe, setEscopoAcesso }) => {
  const navigate = useNavigate();
  const iframeRef = useRef(null);
  const [skeletonLoader, setSkeletonLoader] = useState(true);
  const [iframeKey, setIframeKey] = useState(0);
  const { navegarTela, getDadosSubMenu } = useNavegacao({ setEscopoAcesso });

  useEffect(() => {
    if (scrIframe) {
      setSkeletonLoader(true);
    }
  }, [scrIframe]);

  useEffect(() => {
    window.addEventListener('message', handleResize);
    return () => window.removeEventListener('message', handleResize);
  }, []);

  const salvarRotaIframe = useCallback(data => {
    if (!data?.href) {
      return;
    }

    const partes = window.location.pathname.split('/');
    const idDepartamento64 = partes[2];
    const idSubMenu64 = partes[3];

    if (!idDepartamento64 || !idSubMenu64) return;

    const storageKey = `iframe-route:${idDepartamento64}:${idSubMenu64}`;
    sessionStorage.setItem(storageKey, data.href);
  }, []);

  const abrirAnaliseNovaAba = useCallback(data => {
    if (!data?.rota) {
      return;
    }

    const partes = window.location.pathname.split('/');
    const idDepartamento64 = partes[2];
    const idSubMenu64 = partes[3];

    if (!idDepartamento64 || !idSubMenu64) {
      return;
    }

    const rotaIframe = encodeURIComponent(data.rota);

    window.open(`/iframe/${idDepartamento64}/${idSubMenu64}?rotaIframe=${rotaIframe}`, '_blank');
  }, []);

  const handleResize = useCallback(
    event => {
      if (!event?.data?.type) return;
      if (!origemConfiavel(event.origin)) return;

      switch (event.data.type) {
        case 'iframe-resize':
          setSkeletonLoader(false);
          break;

        case 'token-expirado':
          renovarToken();
          break;

        case 'token-invalido':
          window.location.replace('/force-logout');
          break;

        case 'redirecionar-tela':
          redirecionarTela(event.data);
          break;
        case 'abrir-analise-nova-aba':
          abrirAnaliseNovaAba(event.data);
          break;
        case 'iframe-route-change':
          salvarRotaIframe(event.data);
          break;
        default:
          break;
      }
    },
    [salvarRotaIframe, abrirAnaliseNovaAba]
  );

  const renovarToken = async () => {
    try {
      const newAccessToken = await refreshAccessToken();
      if (newAccessToken) {
        recarregarIframe();
      }
    } catch (err) {
      console.error('Erro ao renovar o token', err);
    }
  };

  const recarregarIframe = () => {
    if (!criaCookieToken()) {
      window.location.replace('/force-logout');
      return;
    }
    setSkeletonLoader(true);
    setIframeKey(prev => prev + 1);
  };

  const enviarMensagemEsteira = useCallback(payload => {
    const iframeWindow = iframeRef.current?.contentWindow;

    if (!iframeWindow || !payload) {
      return false;
    }

    iframeWindow.postMessage(payload, '*');
    return true;
  }, []);

  const redirecionarTela = data => {
    if (!data && !data.tela) {
      return;
    }

    const creditoAnalise = SUBMENUS.CREDITO_ANALISE;

    switch (data.tela) {
      case 'credito-mesa':
        navegarPeloIframe(
          creditoAnalise.CODDEPARTAMENTO,
          creditoAnalise.CODSUBMENU,
          `navegarTela=${data.tela}&cnpj=${data.cnpj ?? ''}&codPpc=${data.codPpc ?? ''}`
        );
        break;

      case 'credito-analise':
        navegarForaIframe(creditoAnalise.CAMINHO, `navegarTela=${data.tela}&codPpc=${data.codPpc}`);
        break;

      default:
        break;
    }
  };

  const navegarPeloIframe = (codDepartamento, codSubMenu, queryString) => {
    navigate(
      `/iframe/${encodeBase64UrlSafe(codDepartamento)}/${encodeBase64UrlSafe(codSubMenu)}?${queryString}`
    );
  };

  const navegarForaIframe = (caminho, queryString) => {
    if (!criaCookieToken()) {
      return;
    }

    const dominioUrl = getConfigAmbienteDominio();
    const url = `${process.env.REACT_APP_ISEVEN_BASE_URL}/AuthKeyCloack.php?url=${caminho}?${queryString}`;
    window.open(url.replace('TENANT', dominioUrl), '_blank');
  };

  return {
    skeletonLoader,
    iframeRef,
    iframeKey,
    navegarTela,
    getDadosSubMenu,
    navigate,
    enviarMensagemEsteira
  };
};

export default IframeComponentHook;
